import React, { FC } from "react";
import { Input, InputGroup } from "rsuite";
import { Radio, RadioGroup } from "@containers/PresetBuilder/components/Radio";
import { EDIT_TYPES } from "@shared/components/ModalEditCountyPrice/ModalEditCountyPrice";

interface ModalMoveUserToAnotherCompanyProps {
  itemType: "price" | "limit";
  value?: number;
  setValue: (value?: number) => void;
  type: EDIT_TYPES;
  setType: (value: EDIT_TYPES) => void;
}

export const EditCountyPriceElement: FC<ModalMoveUserToAnotherCompanyProps> = ({
  itemType,
  type,
  value,
  setValue,
  setType,
}) => {
  const placeholders = {
    [EDIT_TYPES.VALUE]: `Enter a new ${itemType}`,
    [EDIT_TYPES.INCREASE]: `Increase new ${itemType} by`,
    [EDIT_TYPES.DECREASE]: `Decrease new ${itemType} by`,
  };

  return (
    <>
      <div className="small-title">Lead {itemType === "price" ? "Price" : "Limit"}</div>
      <RadioGroup>
        <Radio name={itemType} checked={type === EDIT_TYPES.VALUE} onClick={() => setType(EDIT_TYPES.VALUE)}>
          Set a new {itemType}
        </Radio>
        <Radio name={itemType} checked={type === EDIT_TYPES.INCREASE} onClick={() => setType(EDIT_TYPES.INCREASE)}>
          Increase by
        </Radio>
        <Radio name={itemType} checked={type === EDIT_TYPES.DECREASE} onClick={() => setType(EDIT_TYPES.DECREASE)}>
          Decrease by
        </Radio>
      </RadioGroup>

      <InputGroup>
        {itemType === "price" && <InputGroup.Addon>$</InputGroup.Addon>}
        <Input
          type="number"
          placeholder={placeholders[type]}
          value={value}
          onChange={(val) => setValue(+val || undefined)}
        />
      </InputGroup>
    </>
  );
};
